import ImageFadeIn from "@components/core/ImageFadeIn";
import {
  storyblokImage,
  storyblokSrcSet,
  STORYBLOK_IMAGE_WIDTHS,
} from "@utils/images/storyblokImage";

// Single Storyblok image served through the image service (resized, compressed, webp).
function StoryblokImage({
  src,
  widths = STORYBLOK_IMAGE_WIDTHS.card,
  sizes = "100vw",
  loading = "lazy",
  alt = "",
  ...props
}) {
  if (!src) return null;

  return (
    <ImageFadeIn
      src={storyblokImage(src, { width: widths[widths.length - 1] })}
      srcSet={storyblokSrcSet(src, widths)}
      sizes={sizes}
      loading={loading}
      decoding="async"
      alt={alt}
      {...props}
    />
  );
}

export default StoryblokImage;
